





























import Vue from "vue";
import storeHelper from "../../../store/store-helper";
import ReadCard from "./ReadCard.vue";
import CreateEditCard from "./CreateEditCard.vue";
import ZenyaDialog from "../../../components/dialogs/ZenyaDialog.vue";
import { SnackBarTimeout } from "@/enums";

export default Vue.extend({
    name: "NewsArticleRead",
    components: { ReadCard, CreateEditCard, ZenyaDialog },
    props: {
        value: { type: Boolean, required: true },
        id: { type: Number, required: true },
        currentPortalId: Number
    },
    data: function () {
        return {
            isNew: !this.id || !(this.id > 0),
            newsArticle: {
                title: "",
                canManage: false
            },
            isEditing: false,
            articleLoaded: false
        };
    },

    async created() {
        if (this.id > 0) {
            await this.loadArticle(this.id);
        }
    },
    computed: {
        isReadScreen(): boolean {
            return !this.isEditing && this.articleLoaded;
        },
        okButtonText(): string {
            if (this.isEditing) {
                return this.$t("general.buttons.save").toString();
            }
            return null;
        },
        cancelButtonText(): string {
            if (this.isReadScreen) {
                return this.$t("general.buttons.close").toString();
            } else if (this.isEditing) {
                return this.$t("general.buttons.cancel").toString();
            }
            return null;
        }
    },
    methods: {
        closeDialog() {
            this.$emit("input", false);
        },
        onEdit() {
            this.isEditing = true;
        },
        onCancel() {
            this.isEditing = false;
        },
        async onDelete() {
            const confirmed: boolean = await this.$confirm(
                this.$t(`portal.portals.news.deleteNewsArticle`).toString(),
                this.$t("confirmationMessages.delete", { n: this.$t("newsArticle.confirmationName").toString().toLocaleLowerCase() }).toString()
            );

            if (confirmed) {
                await this.deleteArticle();
            }
        },
        async loadArticle(id: number) {
            const loadedArticle = await storeHelper.newsArticleStore.loadNewsArticleAsync(id);
            this.articleLoaded = true;
            this.newsArticle.title = loadedArticle.title;
            this.newsArticle.canManage = loadedArticle.can_manage;
        },
        async deleteArticle() {
            const result = await storeHelper.newsArticleStore.deleteArticleAsync(this.$props.id);
            if (result) {
                storeHelper.siteStore.setSnackBarMessage(
                    this.$t("general.messages.successfullyDeleted", {
                        var1: this.$t("modules.newsArticle")
                    }).toString(),
                    false,
                    SnackBarTimeout.short
                );
                this.closeDialog();
            }
        }
    }
});
